<!--suppress ALL -->
<template>
  <div class="card-panel">
    <div class="card-head-wrapper">
      <div class="card-head" :class="cardHeadClass">
        <a v-if="hasPreviousLink" @click="$router.go(-1)" class="button is-transparent sec">
          <i class="fas fa-arrow-left"></i>
        </a>
        <div class="intro sec">
          <p class="title is-6" :style="`${!hasSubTitle && 'margin-bottom: 0'}`">{{title}}</p>
          <p v-if="hasSubTitle" class="help">{{subTitle}}</p>
        </div>
        <div v-if="hasLinks" class="links sec">
          <router-link v-for="(link, index) in links" :to="link.url"
                       :key="`link-${index}`"
                       class="link-item has-icon">
            <span class="icon"><i class="fas fa-th"></i></span>
            <span>{{link.name}}</span>
          </router-link>
        </div>
        <div v-if="$scopedSlots.action || $slots.action" class="action sec">
          <slot name="action"/>
        </div>
      </div>
    </div>
    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'annotation';
  import {isEmpty} from 'lodash';

  @Component
  export default class CardPanel extends Vue {

    @Prop({required: true})
    public title: string;

    @Prop({default: '', type: String})
    public subTitle: string;

    @Prop({default: '', type: String})
    public cardHeadClass: string;

    @Prop({default: false, type: Boolean})
    public hasPreviousLink: boolean;

    @Prop({default: []})
    public links: Array<any>;

    public get hasLinks() {
      return !isEmpty(this.links);
    }

    public get hasSubTitle() {
      return !isEmpty(this.subTitle);
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../style/variables_function";

  .card-panel {
    @include b_sh_def(true);
    border-radius: 6px;

    .card-head, .card-body {
      padding: 1.25rem 1.5rem;
    }

    .card-head-wrapper {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      background-color: $color-primary-young;
    }

    .card-body {
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      background-color: white;

      > .columns {
        margin-top: 0;
        margin-bottom: 0;
      }

      .field:not(:last-child) {
        margin-bottom: 1rem;
      }
    }

    .card-head {
      position: relative;
      @include fl_row;
      align-items: center;

      .sec:not(:last-child) {
        margin-right: .5rem;
      }

      a, p, span, i {
        color: white;
      }

      .intro {
        flex: 1;

        p.title {
          font-weight: 400;
          font-size: 1.1rem;
          margin-bottom: .5rem;
        }

        p.text-mute {
          color: $color-text-mute;
        }
      }

      .links {
        @include fl_row;
        position: absolute;
        right: 1.5rem;
        height: 100%;

        .link-item {
          flex: 1;
          height: 100%;
          padding: .75rem;
          width: 100%;
          align-items: center;
          display: flex;

          span.icon {
            display: initial;
          }

          &.router-link-exact-active {
            border-bottom: 5px solid $green;
          }
        }
      }
    }
  }
</style>
